exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-background{width:100%;height:100%;background:rgba(0,0,0,.25);position:fixed;top:0;left:0;z-index:2}.progress-wrapper{height:90px;background:#fff;opacity:.5;z-index:3}.progress-container,.progress-wrapper{position:absolute;width:400px;margin:-100px 0 0 -200px;top:50%;left:50%}.progress-container{height:150px;z-index:4}.progress-container .progress-title{font-size:20px;text-align:center;margin-top:20px;margin-bottom:7px}.progress-container .progress{border-radius:12px;border-color:#000;border-width:2px;height:15px;margin:0 20px}.progress-container .progress .progress-bar{background-color:#406494}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/solver-progress/solver-progress.styl
// module id = 615
// module chunks = 0